import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {IncidentReportsService} from '../../../services/incident-reports.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {UrlService} from '../../../services/url.service';
import {EmailService} from '../../../services/email.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'send-incident-report-modal',
    templateUrl: './send-incident-report-modal.component.html',
    styleUrls: ['./send-incident-report-modal.component.scss']
})

export class SendIncidentReportModalComponent implements OnInit {
    @ViewChild('form') form;
    message = '';
    sender = 'notice@maxcondoclub.ca';
    subject = '';
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    corpNumber = null;
    somethingChanged = false;
    showUsersSpinner = false;
    recipientSearch = '';
    users = [];
    receivers = [];
    saveAsDefault = false;
    placeholders = [
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[INVITATION_LINK]]',
        '[[MY_SIGNATURE]]'
    ];
    attachments = [];

    constructor(
        public incidentReportsService: IncidentReportsService,
        public api: ApiClientService,
        public urlService: UrlService,
        public authenticationService: AuthenticationService,
        public es: EmailService
    ) {}

    ngOnInit() {
        this.attachments = this.incidentReportsService.incidentReportInIncidentReportsModal.attachments.map(item => ({ ...item, checked: true }));
        this.message = this.incidentReportsService.incidentReportInIncidentReportsModal.incident;
        this.subject = `Incident report ${this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportNumber}`;
        this.initSummernote();
        this.getUsers();
        this.urlService.modalOpened.emit();
    }

    onChangeAttachment(value, item) {
        item.checked = value.target.checked;
    }

    onSubmit(form: NgForm): void {
        if(this.receivers.length < 1) {
            toastr.error('Recipients must be entered.');
            return;
        }

        if(!this.subject) {
            toastr.error('Subject must not be empty.');
            return;
        }

        if(!this.message) {
            toastr.error('Message must not be empty.');
            return;
        }

        this.disabledSubmit = true;
        this.showSpinner = true;
        const incident = this.incidentReportsService.incidentReportInIncidentReportsModal;

        let recipients = [];
        this.receivers.forEach(r => {
            recipients.push({
                name: r.fullName,
                email: r.email,
                type: 'staff', //r.role,
                buildingId: incident.buildingId,
                buildingName: incident.buildingName,
                buildingAddress: incident.buildingAddress,
                suiteId: incident.suiteId,
                suiteName: incident.suiteNumber,
                bdId: r.id * (-1) ,
            });
        });

        const filters = [{
            buildingId: incident.buildingId,
            buildingName: incident.buildingName,
            checkedResidents: [incident.suiteId],
            groups: [],
            guestChecked: 0,
            guestCount: 0,
            guestHalfChecked: 0,
            notSetChecked: recipients.length,
            notSetCount: recipients.length,
            notSetHalfChecked: recipients.length,
            occupantChecked: 0,
            occupantCount: 0,
            occupantHalfChecked: 0,
            offsiteResidentChecked: 0,
            offsiteResidentCount: 0,
            offsiteResidentHalfChecked: 0,
            ownerFamilyChecked: 0,
            ownerFamilyCount: 0,
            ownerFamilyHalfChecked: 0,
            ownerOffChecked: 0,
            ownerOffCount: 0,
            ownerOffHalfChecked: 0,
            ownerOnChecked: 0,
            ownerOnCount: 0,
            ownerOnHalfChecked: 0,
            residentChecked: 0,
            residentCount: 0,
            residentHalfChecked: 0,
            residentOnlyNotOnDeedChecked: 0,
            residentOnlyNotOnDeedCount: 0,
            residentOnlyNotOnDeedHalfChecked: 0,
            residentOwnerChecked: 0,
            residentOwnerCount: 0,
            residentOwnerHalfChecked: 0,
            tenantsChecked: 0,
            tenantsCount: 0,
            tenantsHalfChecked: 0
        }];

        const data: any = {
            sender: this.sender,
            subject: this.subject,
            message: this.getEmailTemplate(),
            sendMeCopy: 0,
            filters: JSON.stringify(filters),
            recipients: recipients,
            attachments: this.attachments.filter(item => item.checked == true).map(item => ({
                name: item.name,
                path: item.link,
                fileSize: item.fileSize
            })),
            pmEmail: this.authenticationService.user.email,
            pmMobilePhone: this.authenticationService.user.primaryPhone,
            pmName: this.authenticationService.user.fullName,
            buildingId: [incident.buildingId],
            buildingName: incident.buildingName,
            buildingAddress: incident.buildingAddress,
            status: 'in_progress',
        };
        this.api.post('domainEmails', '/api/v1/mailings', data).subscribe(
            (response) => {
                toastr.success('Incident report has been sent successfully.');
                this.hideModal(form, true);
            },
            error => {
                this.api.errorHandler(error, 'Failed to send invitation');
                this.disabledSubmit = false;
                this.showSpinner = false;
            }
        );
    }

    hideModal(form, closeOnSubmit?) {
        if (this.somethingChanged && !closeOnSubmit) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.incidentReportsService.isSendIncidentReportModalShow = false;
                    this.incidentReportsService.incidentReportInIncidentReportsModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.incidentReportsService.isSendIncidentReportModalShow = false;
            this.incidentReportsService.incidentReportInIncidentReportsModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.somethingChanged = true;
                    this.message = contents;
                }
            },
            toolbar: [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        // const btn = `
        //     <div class="input-group-btn email-placeholders-btn">
        //         <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
        //                 type="button" aria-expanded="false">PL <span class="caret"></span></button>
        //         <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
        //     </div>
        // `;
        //
        // $(btn).insertAfter('[data-original-title="Help"]')
        //     .on('click', 'li a', e => {
        //         summernote.summernote('editor.restoreRange');
        //         summernote.summernote('editor.focus');
        //         summernote.summernote('editor.insertText', e.target.innerText)
        //     });
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('#summernote').summernote('disable');
    }

    // getPlaceholdersHtml(): string {
    //     return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    // }

    getUsers() {
        this.showUsersSpinner = true;
        const url = `/api/users?expand=company,phones&per-page=10000&user_type=property_manager`;
        this.api.get('oauthUrl', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.users = body.entities || [];
            },
            error => this.api.errorHandler(error, 'Failed get Users'),
            () => this.showUsersSpinner = false
        );
    }

    changeAutocompleteValue(receiver) {
        if(!this.receivers.find(r => r.id == receiver.id))
            this.receivers.push(receiver);
        // need timeout here to trigger the changes to UI
        setTimeout(() => {
            this.recipientSearch = '';
            $('#recipientSearch').blur();
        });
    }

    removeEmail(index) {
        this.receivers.splice(index, 1);
    }

    getEmailTemplate() {
        return  '<html>\n' +
                '    <head>\n' +
                '        <style>\n' +
                '           .email-container{' +
                '               pre{' +
                '                   font-family: inherit;\n' +
                '                   font-size: inherit;\n' +
                '                   margin: 0;' +
                '               }' +
                '               .view-daily-report-header{\n' +
                '                   display: block;\n' +
                '                   width: 100%;\n' +
                '               }\n' +
                '\n' +
                '               .view-daily-report-row{\n' +
                '                   width: 100%;\n' +
                '                   display: inline-flex;\n' +
                '               }\n' +
                '               .view-daily-report-header-top{\n' +
                '                   width: 50%;\n' +
                '                   font-size: 18px;\n' +
                '               }\n' +
                '               .view-daily-report-header-data{\n' +
                '                   margin-top: 7px;\n' +
                '                   width: 50%;\n' +
                '                   font-size: 14px;\n' +
                '               }\n' +
                '               table{\n' +
                '                   border-spacing: 0px;\n' +
                '                   border-collapse: collapse;\n' +
                '                   width: 100%;\n' +
                '                   margin-top: 3%;\n' +
                '               }\n' +
                '               th{\n' +
                '                   text-align: left;\n' +
                '                   padding-left: 10px;\n' +
                '               }\n' +
                '               td{\n' +
                '                   border: 1px solid black;\n' +
                '                   padding-left: 10px;\n' +
                '               }\n' +
                '               pre{\n' +
                '                   white-space: pre-wrap;' +
                '                   white-space: -moz-pre-wrap;' +
                '                   white-space: -pre-wrap;' +
                '                   white-space: -o-pre-wrap;' +
                '               }\n' +
                '            }\n' +
                '        </style>\n' +
                '        <title>Incident Report PDF</title>\n' +
                '        <meta charset="UTF-8">\n' +
                '    </head>\n' +
                '    <body>\n' +
                '        <div style="padding: 10%;" class="email-container">\n' +
                (this.incidentReportsService.incidentReportInIncidentReportsModal.securityCompanyLogo ? `<img src="${this.incidentReportsService.incidentReportInIncidentReportsModal.securityCompanyLogo}" width="150" height="75" style="margin-bottom: 10px;">` : '') +
                '            <div class="view-daily-report-header">\n' +
                '                <div class="view-daily-report-row">\n' +
                `                    <div class="view-daily-report-header-top">Incident Report #:
                                       ${this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportNumber ? this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportNumber : '-'}</div>\n` +
                `                    <div class="view-daily-report-header-top">Building Name:
                                                       ${this.incidentReportsService.incidentReportInIncidentReportsModal.buildingName ? this.incidentReportsService.incidentReportInIncidentReportsModal.buildingName : '-'}</div>\n` +
                '                </div>\n' +
                '            </div>\n' +
                '            <div class="view-daily-report-row">\n' +
                `                <div class="view-daily-report-header-top">Unit #:
                                                         ${this.incidentReportsService.incidentReportInIncidentReportsModal.suiteNumber ? this.incidentReportsService.incidentReportInIncidentReportsModal.suiteNumber : '-'}</div>\n` +
                `                <div class="view-daily-report-header-top">Date:
                                                                 ${new Date(this.incidentReportsService.incidentReportInIncidentReportsModal.createdAt).toLocaleDateString()}</div>\n` +
                '            </div>\n' +
                '            <div class="view-daily-report-row">\n' +
                `                <div class="view-daily-report-header-top">Resident:
                                               ${this.incidentReportsService.incidentReportInIncidentReportsModal.residentFullName ? this.incidentReportsService.incidentReportInIncidentReportsModal.residentFullName : '-'}</div>\n` +
                '            </div>\n' +
                '            <div class="view-daily-report-row">\n' +
                `                <div class="view-daily-report-header-top">Address:
                                                         ${this.incidentReportsService.incidentReportInIncidentReportsModal.buildingAddress ? this.incidentReportsService.incidentReportInIncidentReportsModal.buildingAddress : '-'}</div>\n` +
                '            </div>\n' +
                '            <div class="view-daily-report-row" style="margin-top: 2%;">\n' +
                `                <div class="view-daily-report-header-top">Reported By:
                                                           ${this.incidentReportsService.incidentReportInIncidentReportsModal.reportedBy ? this.incidentReportsService.incidentReportInIncidentReportsModal.reportedBy : '-'}</div>\n` +
                `                <div class="view-daily-report-header-top">Created By:
                                                    ${this.incidentReportsService.incidentReportInIncidentReportsModal.createdBy ? (<any>this.incidentReportsService.incidentReportInIncidentReportsModal.createdBy).fullName : '-'}</div>\n` +
                '            </div>\n' +
                '\n' +
                '            <table>\n' +
                '                <tr>\n' +
                '                    <th style="width: 60%;">Incident Type</th>\n' +
                '                    <th>Date Occurred</th>\n' +
                '                    <th>Time Occurred</th>\n' +
                '                </tr>\n' +
                '                <tr>\n' +
                `                    <td>${this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportType ? this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportType.name : (this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportTypeOther ? this.incidentReportsService.incidentReportInIncidentReportsModal.incidentReportTypeOther :  '-')}</td>\n` +
                `                    <td>${new Date(this.incidentReportsService.incidentReportInIncidentReportsModal.createdAt).toLocaleDateString()}</td>\n` +
                `                    <td>${new Date(this.incidentReportsService.incidentReportInIncidentReportsModal.createdAt).toLocaleTimeString()}</td>\n` +
                '                </tr>\n' +
                '            </table>\n' +
                '\n' +
                '            <div style="margin-top: 3%; border: solid 1px;">\n' +
                '                <div style="border-bottom: solid 1px;">Reported Area: </div>\n' +
                `                <div style="border-bottom: solid 1px;">
                                                              ${this.incidentReportsService.incidentReportInIncidentReportsModal.reportedArea ? this.incidentReportsService.incidentReportInIncidentReportsModal.reportedArea : '-'} </div>\n` +
                '                <div style="border-bottom: solid 1px;">Report: </div>\n' +
                `                <div><pre>${this.incidentReportsService.incidentReportInIncidentReportsModal.incident ? this.incidentReportsService.incidentReportInIncidentReportsModal.incident : '-'}</pre></div>\n` +
                '            </div>\n' +
                '        </div>\n' +
                '    </body>\n' +
                '</html>';
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(this.form), 100);
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/send-incident-report-modal/send-incident-report-modal.component.ts